import { gql } from "@apollo/client";

export const GET_MERGE_HISTORY = gql`
  query getMergeHistory($companyId: ID!) {
    getMergeHistory(companyId: $companyId) {
      _id
      status
      sourceCompany {
        _id
        companyName
      }
      targetCompany {
        _id
        companyName
      }
      mergedBy {
        firstName
        lastName
        email
      }
      totalRecords {
        listings
        users
        offices
        amenities
        services
      }
      transferredRecords {
        listings
        users
        offices
        amenities
        services
      }
      startTime
      endTime
      duration
      conflictsResolved
      rollbackDate
      rollbackReason
      createdAt
      updatedAt
    }
  }
`;

export const GET_MERGE_DETAILS = gql`
  query getMergeDetails($mergeId: ID!) {
    getMergeDetails(mergeId: $mergeId) {
      merge {
        _id
        status
        sourceCompany {
          _id
          companyName
        }
        targetCompany {
          _id
          companyName
        }
        mergedBy {
          firstName
          lastName
          email
        }
        totalRecords {
          listings
          users
          offices
          amenities
          services
        }
        transferredRecords {
          listings
          users
          offices
          amenities
          services
        }
        startTime
        endTime
        duration
        conflictsResolved
        logs
        rollbackDate
        rollbackReason
        createdAt
      }
      historyEntries {
        _id
        recordType
        status
        metadata {
          recordTitle
          notes
        }
        conflictResolution {
          hadConflict
          conflictType
          resolution
          details
          originalValue
          newValue
        }
        transferredAt
        createdAt
      }
    }
  }
`;

export const GET_MERGES_BY_STATUS = gql`
  query getMergesByStatus($status: MergeStatus!) {
    getMergesByStatus(status: $status) {
      _id
      status
      sourceCompany {
        _id
        companyName
      }
      targetCompany {
        _id
        companyName
      }
      mergedBy {
        firstName
        lastName
        email
      }
      totalRecords {
        listings
        users
        offices
        amenities
        services
      }
      transferredRecords {
        listings
        users
        offices
        amenities
        services
      }
      createdAt
      startTime
      endTime
      duration
    }
  }
`;

export const INITIATE_MERGE = gql`
  mutation initiateMerge($input: InitiateMergeInput!) {
    initiateMerge(input: $input) {
      _id
      status
      sourceCompany {
        _id
        companyName
      }
      targetCompany {
        _id
        companyName
      }
      mergedBy {
        firstName
        lastName
        email
      }
      totalRecords {
        listings
        users
        offices
        amenities
        services
      }
      createdAt
    }
  }
`;

export const EXECUTE_MERGE = gql`
  mutation executeMerge($mergeId: ID!) {
    executeMerge(mergeId: $mergeId) {
      _id
      status
      sourceCompany {
        _id
        companyName
      }
      targetCompany {
        _id
        companyName
      }
      transferredRecords {
        listings
        users
        offices
        amenities
        services
      }
      startTime
      endTime
      duration
      conflictsResolved
      logs
    }
  }
`;

export const ROLLBACK_MERGE = gql`
  mutation rollbackMerge($input: RollbackMergeInput!) {
    rollbackMerge(input: $input) {
      _id
      status
      sourceCompany {
        _id
        companyName
      }
      targetCompany {
        _id
        companyName
      }
      rollbackDate
      rollbackReason
      updatedAt
    }
  }
`;